<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  @let formGroup = $formGroup();
  <unity-card-new-shared
    actionName="Send Registration to User"
    [formGroup]="formGroup"
    [formLoading]="$formLoading()"
    (submitEvent)="onSubmit()">
    <unity-dropdown-agency-control
      displayName="Business Partner"
      description="Select the business partner for which the new user is working."
      filter="internal"
      [control]="formGroup.controls.agency_id"
      (selectionChangeEvent)="onAgencySelect($event)" />
    <unity-textbox-control
      displayName="Username"
      description="Enter the username of the existing AHFC user. They will receive a confirmation email once you submit this form."
      [control]="formGroup.controls.user_name"
      [suffix]="suffix" />
    @let selectedAgencyId = $selectedAgencyId();
    @if (selectedAgencyId) {
      <unity-dropdown-control
        displayName="Role"
        description="Select the new user's role at this agency."
        [control]="formGroup.controls.role_id"
        [values]="$inputRoles()?.data ?? []" />
    }
  </unity-card-new-shared>
</unity-page-container>
